// components/SideNavbar.js

import styles from '../../styles/SideNavbar.module.css';
import { useState } from 'react';
import { useRouter } from 'next/router';

const SideNavbar = ({isOpen, closeSidebar }) => {
    const router = useRouter();
    const { id } = router.query;
    const [isHovered, setIsHovered] = useState(false);
    const [isClicked, setClicked] = useState(false);
    

  const categories = [

    { name: "Home", iconUrl: "/assets/sidenav/home.svg", pageUrl: "/" },
    { name: "New Games", iconUrl: "/assets/sidenav/new-games.svg", pageUrl: "new-games" },
    { name: "Racing Games", iconUrl: "https://cdncloud.cutedressup.in/bestgamespot/website/logo/racing.svg", pageUrl: "racing-games" },
    { name: "Action Games", iconUrl: "https://cdncloud.cutedressup.in/bestgamespot/website/logo/action.svg", pageUrl: "action-games" },
    { name: "Arcade Games", iconUrl: "https://cdncloud.cutedressup.in/bestgamespot/website/logo/arcade.svg", pageUrl: "arcade-games" },
    { name: "Puzzle Games", iconUrl: "https://cdncloud.cutedressup.in/bestgamespot/website/logo/puzzle.svg", pageUrl: "puzzle-games" },
    { name: "Girl Games", iconUrl: "https://cdncloud.cutedressup.in/bestgamespot/website/logo/girl.svg", pageUrl: "girl-games" },
    { name: "Shooting Games", iconUrl: "https://cdncloud.cutedressup.in/bestgamespot/website/logo/shooting.svg", pageUrl: "shooting-games" },
    { name: "Fighting Games", iconUrl: "https://cdncloud.cutedressup.in/bestgamespot/website/logo/fighting.svg", pageUrl: "fighting-games" },
    { name: "Multiplayer Games", iconUrl: "https://cdncloud.cutedressup.in/bestgamespot/website/logo/multiplayer.svg", pageUrl: "multiplayer-games" },
    { name: "3D Games", iconUrl: "https://cdncloud.cutedressup.in/bestgamespot/website/logo/3d.svg", pageUrl: "3d-games" },
    { name: "IO Games", iconUrl: "https://cdncloud.cutedressup.in/bestgamespot/website/logo/io.svg", pageUrl: "io-games" },
    { name: "All Categories", iconUrl: "/assets/sidenav/all-tag.svg", pageUrl: "all-categories" },

  ];
//   console.log(`Current: ${router.pathname}, Category: ${category.name}, URL: ${category.pageUrl}, isActive: ${isActive}`);



const CurretnPath = () => {
  return `/${{ id }.id}`;
};



return (


<>
      {isOpen && (<div className='contant name'> Is open </div>)}
      {(isOpen || isHovered) && <div className={styles.overlay} onClick={closeSidebar}></div>}
    <div className={styles.sideNavbar} style={{
      width:(isOpen || isHovered) ? '200px' : '0px', // Mobile handling
      transition: 'width 0.3s ease', 
    }}
    onClick={closeSidebar}
      
        onMouseEnter={() => setIsHovered(true)}  // Show overlay on hover
        onMouseLeave={() => setIsHovered(false)} // Hide overlay when hover stops
    >
      <ul>
        {categories.map((category, index) => {
          const isActive = category.pageUrl === "/" ? router.pathname === "/" :CurretnPath() === `/${category.pageUrl}`;
          const isAlltag = category.pageUrl === "all-categories" ? router.pathname === "/all-categories" :CurretnPath() === `/${category.pageUrl}`;
          const isBlog = category.pageUrl === "blog" ? router.pathname === "/blog" :CurretnPath() === `/${category.pageUrl}`;
           

          return (
            <li
            
              key={index}
              className={`${styles.categoryItem} ${isActive ? styles.active : ''} ${isAlltag ? styles.active : ''} ${isBlog ? styles.active : ''} `}
              onClick={() => {
                {isOpen && setIsHovered(false)}
                {!isOpen && setClicked(true)}
                router.push(category.pageUrl === "/" ? "/" : category.pageUrl === "all-categories" ? "/all-categories" : category.pageUrl === "blog" ? "/blog" :`/${category.pageUrl}`)}}>
              <img src={category.iconUrl} alt={category.name} className={styles.icon} />
              <span className={styles.categoryName}>{category.name}</span>
            </li>
          );
        })}
      </ul>
    </div>
    </>
  );
};

export default SideNavbar;
